import { render, staticRenderFns } from "./ArBalanceForCPA.vue?vue&type=template&id=36ece0c8&scoped=true&"
import script from "./ArBalanceForCPA.vue?vue&type=script&lang=js&"
export * from "./ArBalanceForCPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ece0c8",
  null
  
)

export default component.exports